import { Component, ViewChild, ElementRef, Inject } from '@angular/core';
import { faSignIn, faKey } from '@fortawesome/free-solid-svg-icons';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import * as bootstrap from 'bootstrap';
import { SignupComponent } from '../signup/signup.component';
import { Router } from '@angular/router';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, InteractionType, PopupRequest, PromptValue, RedirectRequest } from '@azure/msal-browser';
import { b2cPolicies } from 'src/app/config/auth-config';
import { environment } from 'src/environments/environment';
import { AuthService } from './../../core/services/auth/auth.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
    disableLoginButton: boolean = false;
    isLoading: boolean = false;

    azureLogin() {
        this.disableLoginButton = true;
        this.isLoading = true;
        // debugger;
        const signUpSignInFlowRequest: PopupRequest = {
            authority: b2cPolicies.authorities.signUpSignIn.authority,
            prompt: PromptValue.LOGIN, // force user to reauthenticate with their new password
            scopes: [],
            redirectUri: environment.appUrl,
        };

        this.login(signUpSignInFlowRequest);
    }
    faGoogle = faGoogle;
    faSignIn = faSignIn;
    faKey = faKey;
    @ViewChild('logInModal') logInModal!: ElementRef; // Reference to the modal
    constructor(
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private msalService: MsalService,
        private authService: AuthService,
    ) {
        // debugger;
    }
    @ViewChild(SignupComponent) signUpInstance!: SignupComponent;
    openLogInModal() {
        const modalElement = this.logInModal.nativeElement;
        const modalInstance = new bootstrap.Modal(modalElement);
        modalInstance.show();
    }

    closeLogInModal() {
        const modalElement = this.logInModal.nativeElement;
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
            modalInstance.hide(); // Call hide() on the existing modal instance if it exists
        }
    }

    openSignUpModal() {
        this.closeLogInModal();
        this.signUpInstance.openSignUpModal();
    }

    closeSignUpModal() {
        this.signUpInstance.closeSignUpModal();
    }

    login(userFlowRequest?: RedirectRequest | PopupRequest) {
        if (this.msalGuardConfig.authRequest) {
            this.msalService.loginRedirect({ ...this.msalGuardConfig.authRequest, ...userFlowRequest } as RedirectRequest);
        } else {
            this.msalService.loginRedirect(userFlowRequest);
        }
    }
}

// import { Component } from '@angular/core';
// import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { faSignIn, faKey } from '@fortawesome/free-solid-svg-icons';

// @Component({
//     selector: 'app-login',
//     templateUrl: './login.component.html',
//     styleUrls: ['./login.component.scss'],
// })
// export class LoginComponent {
//     closeResult = '';
//     faSignIn = faSignIn;
//     faKey = faKey;
//     constructor(private modalService: NgbModal) {}

//     open(content: any) {
//         this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
//             (result) => {
//                 this.closeResult = `Closed with: ${result}`;
//             },
//             (reason) => {
//                 this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
//             },
//         );
//     }

//     private getDismissReason(reason: any): string {
//         if (reason === ModalDismissReasons.ESC) {
//             return 'by pressing ESC';
//         } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
//             return 'by clicking on a backdrop';
//         } else {
//             return `with: ${reason}`;
//         }
//     }
// }
